import { AdminUserPermissionsEnum, UserAccountStatusEnum } from '@/lib/enum';
import { useFormSetCoinsToUser } from '@/hooks/forms';
import { SecuredComponent } from '@/components/hoc';
import { getUserCoinCount } from '@/lib/utils';
import { Ellipsis, Eye, Gift } from 'lucide-react';
import { Link } from 'react-router-dom';
import routes from '@/lib/routes';
import { IHasUser } from '.';
import {
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenu,
  TableCell,
  Button
} from '@/components/ui';

export const DataTableBodyCellOptions = ({ user }: IHasUser) => {

  const { openAddCreditsModal } = useFormSetCoinsToUser();

  const handleOnClickBtnAddCredits = (e: any) => {
    e.stopPropagation();
    openAddCreditsModal({
      user: {
        coins: getUserCoinCount(user.coins, user.diamondWallet?.coins),
        username: user.username,
        id: user._id
      }
    });
  };

  const handleOnClickBtnOption = (e: any) =>
    e.stopPropagation();

  let content = (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button
          onClick={handleOnClickBtnOption}
          className='h-7 py-1'
          variant={'ghost'}
          size={'sm'}>
          <Ellipsis size={16} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className='min-w-36' align='end'>
        <DropdownMenuGroup>
          <SecuredComponent permissionsRequired={[
            AdminUserPermissionsEnum.ADD_REMOVE_USER_COINS,
            AdminUserPermissionsEnum.ADD_REMOVE_USER_INCOGNITO,
            AdminUserPermissionsEnum.ADD_REMOVE_USER_BOOST
          ]}>
            <DropdownMenuItem
              className='cursor-pointer'
              disabled={user.accountStatus === UserAccountStatusEnum.SUSPENDED}
							title="Ajouter des pièces, de l'incognito ou du boost à cet utilisateur"
              onClick={handleOnClickBtnAddCredits}>
              <Gift size={16} />
              <span className='mr-3'>
                Ajouter des crédits
              </span>
            </DropdownMenuItem>
          </SecuredComponent>
          <DropdownMenuItem className='cursor-pointer'>
            <Link
              to={routes.nav.users.single.getHref(user._id)}
              className='flex items-center space-x-2'>
              <Eye />
              <span>
                Voir
              </span>
            </Link>
          </DropdownMenuItem>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );

  return (
    <TableCell className='py-1 px-2 w-0'>
      {content}
    </TableCell>
  );

};

export default DataTableBodyCellOptions;
